import type { Theme } from '../types';
import type { Components } from '@mui/material/styles';

export const MuiButtonBase = {
  defaultProps: { disableRipple: true },
} satisfies Components<Theme>['MuiButtonBase'];
